import { render, staticRenderFns } from "./Navbarcalendar.vue?vue&type=template&id=1d5a62b6&"
import script from "./Navbarcalendar.vue?vue&type=script&lang=js&"
export * from "./Navbarcalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports